import React from "react";
import { Clock, ShieldCheck, Euro, Award, Truck, Headphones } from "lucide-react";

const IMG1 =
  "https://images.pexels.com/photos/7859953/pexels-photo-7859953.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG2 =
  "https://images.pexels.com/photos/8486978/pexels-photo-8486978.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const ITEMS = [
  { Icon: Clock, title: "30 min chrono", desc: "Délai moyen d'intervention dans tout le 93." },
  { Icon: Euro, title: "Tarifs transparents", desc: "Devis ferme, pas de majoration nuit ni week-end." },
  { Icon: ShieldCheck, title: "Garantie 3 mois", desc: "Tout bouchon récidivant repris gratuitement." },
  { Icon: Award, title: "15 ans d'expertise", desc: "Plombiers certifiés et formés en continu." },
  { Icon: Truck, title: "Matériel pro", desc: "Camions hydrocureurs et caméras endoscopiques." },
  { Icon: Headphones, title: "Standard 24/7", desc: "Un conseiller humain répond à chaque appel." },
];

export const WhyUs = () => (
  <section className="py-20 md:py-28 bg-[#F1F5F9]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <div className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-[#FF5A1F] mb-4">
            Pourquoi nous choisir
          </div>
          <h2
            className="text-4xl sm:text-5xl font-extrabold tracking-tight text-[#0F172A] mb-5"
            style={{ fontFamily: "'Cabinet Grotesk','Manrope', sans-serif" }}
          >
            Le réflexe sûr pour le 93.
          </h2>
          <p className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed">
            Depuis 2010, l'entreprise <strong>Débouchage</strong> intervient dans toute
            la Seine-Saint-Denis avec une exigence : un travail soigné, des tarifs
            honnêtes et une garantie réelle sur chaque prestation.
          </p>
          <div className="grid grid-cols-2 gap-4">
            <img
              src={IMG1}
              alt="Depannage volet roulant Cergy"
              className="rounded-2xl object-cover w-full h-44"
              loading="lazy"
            />
            <img
              src={IMG2}
              alt="Depannage volet roulant Cergy"
              className="rounded-2xl object-cover w-full h-44 mt-8"
              loading="lazy"
            />
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
          {ITEMS.map(({ Icon, title, desc }, i) => (
            <div
              key={i}
              data-testid={`whyus-card-${i}`}
              className="bg-white border border-slate-200 rounded-2xl p-6 hover:-translate-y-1 hover:shadow-lg transition-all"
            >
              <div className="w-11 h-11 rounded-lg bg-[#FF5A1F]/10 text-[#FF5A1F] flex items-center justify-center mb-4">
                <Icon className="w-5 h-5" strokeWidth={2.4} />
              </div>
              <div className="font-extrabold text-[#0F172A] text-lg mb-1 tracking-tight">
                {title}
              </div>
              <p className="text-slate-600 text-sm leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default WhyUs;
